// Scheduled maintenance notice: a bar above every Console page, logged in or
// not (the public docs too), and a notice on the login and get access screens
// in place of the rebrand one.
// It shows from a few days before the work until it ends, then it's gone.
// Dates are YYYY-MM-DD in UTC and inclusive. The same notice (same id, dates
// and copy) lives in Insights, so change both together.
//
// If the work runs over, move `until` here and redeploy.

export const SCHEDULED_MAINTENANCE = {
  // Closing is remembered under this id: give new maintenance a new one.
  id: "maintenance-2026-10",
  from: "2026-10-23",
  until: "2026-10-28",
  title: "Scheduled maintenance 26 to 28 October",
  detail: "Some services may be briefly unavailable.",
}

export type Maintenance = typeof SCHEDULED_MAINTENANCE

// The notice for `today`, or null outside its dates. `preview` (from
// `?maintenance=on`) shows it early, to review it.
export function getCurrentMaintenance(
  today: string = new Date().toISOString().slice(0, 10),
  preview = false,
): Maintenance | null {
  const { from, until } = SCHEDULED_MAINTENANCE
  return preview || (today >= from && today <= until)
    ? SCHEDULED_MAINTENANCE
    : null
}
